import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { useState } from "react";



function DeleteUser(props) { 
    const [dialogOpen, setDialogOpen]                   = useState(false);

    const {obj, onDeleteUser } = props;

    const openDialog = ()=> {
        setDialogOpen(true);
    }
    
    const closeDialog =()=>{
        setDialogOpen(false);
    }

    return (
        <div> 
            <Button onClick={openDialog}>
                <DeleteIcon />
            </Button>
            <Dialog
                open={dialogOpen}
                maxWidth={'sm'}
                onClose={closeDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete User?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <DialogActions>
                            <Button onClick={closeDialog} size="large" variant="outlined"  color="primary">
                                Cancel
                            </Button>
                            <Button 
                                variant="outlined" 
                                onClick={()=>{
                                    onDeleteUser(obj.id)
                                    closeDialog()
                                }} 
                                size="large" 
                                type="submit" 
                                autoFocus
                            >
                                Delete
                            </Button> 
                        </DialogActions>
                    </DialogContentText>
                </DialogContent>       
            </Dialog>
        </div>
    )
}

DeleteUser.propTypes = {
    obj: PropTypes.object,
    onDeleteUser: PropTypes.func,
};

export default DeleteUser
